// libs
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './styles.scss';

function Sharer(props, { t }) {
  return (
    <div className="sharer">
      <button
        className="sharer__button sharer__button--print"
        onClick={() => window.print()}
      >
        <span>{t('pages.print')}</span>
      </button>
    </div>
  );
}

Sharer.propTypes = {};
Sharer.contextTypes = {
  t: PropTypes.func,
};

export default Sharer;




// WEBPACK FOOTER //
// ./src/app/components/tools/share/Sharer.js